































































































































import request from '@/graphql/request';
import IDevice from '@/interfaces/device';
import UpdateDeviceMutation from '@/graphql/mutations/updateDevice.gql';
import RefreshDeviceTokenMutation from '@/graphql/mutations/refreshDeviceToken.gql';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ServerCommandDisplay from './ServerCommandDisplay.vue';

@Component({
  components: {
    ServerCommandDisplay,
  }
})
export default class DeviceInfoDisplay extends Vue {
  @Prop({ required: true })
  public device!: IDevice

  @Prop({ required: true })
  public showMoreInfo!: boolean;

  @Prop({ required: false })
  public warningMessage!: string;

  public newNickname = this.device.nickname;
  public isNameBeingChanged: boolean = false;
  public newTag = this.device.deviceTag;
  public isTagBeingChanged: boolean = false;
  public showToken: boolean = false;
  public errorMessage = '';
  public tokenGenerated: string | null = null;
  public internalDevice!: IDevice;
  public internalWarningMessage: string = '';

  public get warning() {
    return this.warningMessage || this.internalWarningMessage;
  }

  public created() {
    this.internalDevice = this.device;
  }

  public startChangeName() {
    this.isNameBeingChanged = true;
  }

  public endChangeName(newNickname: string) {
    const id = this.internalDevice.id;
    this.isNameBeingChanged = false;

    if (newNickname.length > 0 && newNickname !== this.internalDevice.nickname) {
      request(UpdateDeviceMutation as any, {
        id,
        fields: {
          nickname: newNickname,
        },
      })
        .then(({ data, errors }) => {
          if (errors && errors.length && errors.length > 0) {
            throw new Error();
          }
          this.internalDevice.nickname = this.newNickname = newNickname;
        })
        .catch(error => {
          this.errorMessage = 'Device nickname change failed.';
        });
    }
  }

  public startTagChange() {
    this.isTagBeingChanged = true;
  }

  public endTagChange(newTag: string) {
    const id = this.device.id;
    this.isTagBeingChanged = false;

    if (newTag.length > 0 && newTag !== this.internalDevice.deviceTag) {
      request(UpdateDeviceMutation as any, {
        id,
        fields: {
          deviceTag: newTag,
        },
      })
        .then(({ data, errors }) => {
          if (errors && errors.length && errors.length > 0) {
            throw new Error();
          }
          this.internalDevice.deviceTag = this.newTag = newTag;
          this.internalWarningMessage = `Please remember to change the tag on \"${this.internalDevice.nickname}\" or new data will not be sent to the server.`;
        })
        .catch(error => {
          this.errorMessage = 'Device tag change failed.';
        });
    }
  }

  public refreshToken() {
    const deviceId = this.internalDevice.id;

    request(RefreshDeviceTokenMutation as any, { deviceId })
      .then(({ data, errors }) => {
        if (errors && errors.length && errors.length > 0) {
          throw new Error();
        }
        this.internalDevice.deviceToken = {
          ...this.internalDevice.deviceToken,
          token: data.refreshDeviceToken
        };

        this.internalWarningMessage = `Please remember to change the token on \"${this.internalDevice.nickname}\" or new data will not be sent to the server.`;
      })
      .catch(error => {
        this.internalWarningMessage = '';
        this.errorMessage = 'Device token refresh failed.';
      });
  }

  public showDeviceMessages(deviceId: string) {
    this.$router.push('/device/' + deviceId);
  }

  @Watch('device')
  public onDeviceChanged() {
    this.internalDevice = this.device;
  }
}
